import useProgress from './useProgress';
import { useEffect } from 'react';
export function useSetProgress(phase, step) {
    var _a = useProgress(), setPhase = _a.setPhase, setStep = _a.setStep;
    useEffect(function () {
        setPhase(phase || 0);
        setStep(step || 0);
    }, [phase, step]);
}
export default useSetProgress;
